import { Button } from "@/components/ui/button/button";
import { useNavigate } from "@tanstack/react-router";

const CardViewTestPage = () => {
	const navigate = useNavigate();
	return (
		<div className="h-full">
			<div className="flex items-end justify-between px-6">
				<p className="mt-3 text-2xl font-bold text-textDark">My Cards</p>

				<Button
					variant="link"
					className="rounded-[70px] border-primary-500 border-[1px] px-2 py-[2px]"
					onClick={() => navigate({ to: "/main/card/new" })}
				>
					+Add Card
				</Button>
			</div>
			<div className="h-full mt-7">
				{/*         {pageStep === "add" ? (
          <AddCreditCard setPageStep={setPageStep} type="card" />
        ) : (
          <CardView />
        )} */}
			</div>
		</div>
	);
};

export default CardViewTestPage;
